module.exports = __webpack_public_path__ + "static/media/Hbook-05.38ff47bb.jpg";